import 'aos/dist/aos.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@assets/css/mobile-menu.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import '@assets/scss/main.scss';
import '@assets/css/blog-mobile.css';

// Desabilitar o scroll restoration do navegador
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
}: any) => {
    // Se há um hash na URL, deixa o navegador lidar com o scroll para a âncora
    if (location.hash) {
        return false;
    }

    // Sempre rola para o topo ao navegar para uma nova página
    window.setTimeout(() => window.scrollTo(0, 0), 0);

    return false;
};

// Garantir scroll ao topo após a navegação ser concluída
export const onRouteUpdate = ({ location, prevLocation }: any) => {
    // Se não há hash na URL, força scroll para o topo de forma agressiva
    if (!location.hash) {
        window.scrollTo(0, 0);
        // Força novamente após um frame
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        // E mais uma vez após um pequeno delay
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);
    }
};
